// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__MqEmW","description":"PatientConsentPreview_description__1bgIK"};